// WarmCompanionCareSection.js
import React from "react";
import { Phone } from "lucide-react";
import companionCareImage from "../assets/warm-companion-care-image.jpg";

const WarmCompanionCareSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Warm, Compassionate Companion Care for Seniors at Home
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                At Allawah Lodge, we understand that companionship is{" "}
                <span className="text-[#E85D2C] font-normal">essential</span> to
                a happy, healthy life. Our companion care services are designed
                to provide not just assistance, but also meaningful connection
                and social engagement for seniors who may be feeling isolated.
                We believe that no one should feel alone, and our caregivers are
                here to offer a friendly face, a listening ear, and a helping
                hand.
              </p>

              <p>
                Companion care is a non-medical in-home care service focused on
                providing social and emotional support to seniors. It helps
                prevent loneliness and isolation, which are common challenges
                for older adults, especially those living alone. Our caregivers
                act as trusted friends, engaging clients in conversation,
                hobbies, and activities to keep their minds sharp and spirits
                high.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={companionCareImage}
              alt="Young woman embracing elderly woman outdoors"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WarmCompanionCareSection;
